<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="social-links">
        <a
          href="https://www.linkedin.com/in/david-van-der-merwe-693454131/"
          target="_blank"
          rel="noopener noreferrer"
          class="social-icon-link linkedin"
          aria-label="LinkedIn"
        >
          <font-awesome-icon :icon="['fab', 'linkedin']" size="xl" />
        </a>
        <a
          href="https://github.com/thedawie"
          target="_blank"
          rel="noopener noreferrer"
          class="social-icon-link github"
          aria-label="GitHub"
        >
          <font-awesome-icon :icon="['fab', 'github']" size="xl" />
        </a>
        <a
          href="https://twitter.com/thedawie"
          target="_blank"
          rel="noopener noreferrer"
          class="social-icon-link twitter"
          aria-label="Twitter"
        >
          <font-awesome-icon :icon="['fab', 'twitter']" size="xl" />
        </a>
        <a
          href="https://www.instagram.com/thedawie/"
          target="_blank"
          rel="noopener noreferrer"
          class="social-icon-link instagram"
          aria-label="Instagram"
        >
          <font-awesome-icon :icon="['fab', 'instagram']" size="xl" />
        </a>
      </div>
      <p class="copyright">© {{ currentYear }} David Van Der Merwe</p>
    </div>
  </footer>
</template>

<script setup>
const currentYear = new Date().getFullYear();
</script>

<style scoped>
.site-footer {
  width: 100%;
  margin-top: auto;
  padding: 40px 20px 50px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.social-links {
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;
}

.social-icon-link {
  color: #9ca3af;
  font-size: 1.25rem;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
}

.social-icon-link:hover {
  transform: translateY(-3px) scale(1.08);
}

.social-icon-link.linkedin:hover {
  color: #0a66c2;
  background: rgba(10, 102, 194, 0.15);
}

.social-icon-link.github:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.15);
}

.social-icon-link.twitter:hover {
  color: #1da1f2;
  background: rgba(29, 161, 242, 0.15);
}

.social-icon-link.instagram:hover {
  color: #e1306c;
  background: rgba(225, 48, 108, 0.15);
}

.copyright {
  font-size: 0.85rem;
  color: #6b7280;
}
</style>